export const translations = {
  tr: {
    appName: "ZEN ERP",
    tagline: "Mekanizmalı Perde Sistemleri",
    login: "Giriş Yap",
    logout: "Çıkış",
    email: "E-posta",
    password: "Şifre",
    signIn: "Giriş",
    dashboard: "Ana Ekran",
    orders: "Siparişler",
    production: "Üretim",
    shipping: "Kargo",
    pricing: "Fiyat Listeleri",
    customers: "Cari Hesaplar",
    accounting: "Muhasebe",
    inventory: "Depo & Stok",
    reports: "Raporlar",
    newOrder: "Yeni Sipariş",
    searchPlaceholder: "Sipariş, müşteri ara...",
    imalatta: "İmalatta",
    kargolanacak: "Kargolanacak",
    yollandi: "Yollandı - Ödeme Bekliyor",
    odendi: "Ödendi",
    ship: "Yollandı",
    requestPayment: "Ödeme İste",
    markPaid: "Ödemesi Alındı",
    total: "Toplam",
    customer: "Müşteri",
    deadline: "Termin",
    status: "Durum",
    actions: "İşlemler",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    print: "Yazdır",
    pdf: "PDF",
    role: "Rol",
    admin: "Yönetici",
    sales: "Satış",
    prodRole: "Üretim",
  },
  en: {
    appName: "ZEN ERP",
    tagline: "Mechanical Curtain Systems",
    login: "Sign In",
    logout: "Logout",
    email: "Email",
    password: "Password",
    signIn: "Sign In",
    dashboard: "Dashboard",
    orders: "Orders",
    production: "Production",
    shipping: "Shipping",
    pricing: "Price Lists",
    customers: "Accounts",
    accounting: "Accounting",
    inventory: "Inventory",
    reports: "Reports",
    newOrder: "New Order",
    searchPlaceholder: "Search orders, customers...",
    imalatta: "In Production",
    kargolanacak: "Ready to Ship",
    yollandi: "Shipped - Awaiting Payment",
    odendi: "Paid",
    ship: "Mark Shipped",
    requestPayment: "Request Payment",
    markPaid: "Mark Paid",
    total: "Total",
    customer: "Customer",
    deadline: "Deadline",
    status: "Status",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    print: "Print",
    pdf: "PDF",
    role: "Role",
    admin: "Admin",
    sales: "Sales",
    prodRole: "Production",
  },
};

export const CURRENCY_SYMBOL = { TL: "₺", EUR: "€", USD: "$" };

export const STATUS_LABELS = {
  teklif:                  { tr: "Teklif",                      en: "Quote",              color: "sky"     },
  onay_bekliyor:           { tr: "Onay Bekliyor",               en: "Pending Approval",   color: "indigo"  },
  imalata_hazir:           { tr: "Onaylandı / İmalata Hazır",   en: "Approved / Ready",   color: "emerald" },
  imalatta:                { tr: "İmalatta",                    en: "In Production",      color: "amber"   },
  hazir:                   { tr: "Hazır",                       en: "Ready",              color: "violet"  },
  kargolanacak:            { tr: "Kargoya Verilecek",           en: "Ready to Ship",      color: "orange"  },
  yollandi:                { tr: "Yollandı",                    en: "Shipped",            color: "emerald" },
  teslim_odeme_bekliyor:   { tr: "Teslim / Ödeme Bekliyor",     en: "Delivered / Awaiting Payment", color: "yellow" },
  odendi:                  { tr: "Ödendi",                      en: "Paid",               color: "green"   },
  iptal:                   { tr: "İptal",                       en: "Cancelled",          color: "rose"    },
  tamamlandi:              { tr: "Tamamlandı",                  en: "Completed",          color: "teal"    },
};
